import { SparkleIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import { labelForToken } from 'app/lib/workflows/dataContext'
import { humanizeTokens } from 'app/lib/workflows/messageFallbacks'
import type { AiAgentSmsFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Briefs the AI agent and sends the opening text, then completes: one output, like Send SMS.
 *  The card shows the BRIEF, not the opener, because the brief is what the agent pursues for the
 *  whole conversation and the opener is a single text. */
export function AiAgentSmsNode({ data, selected }: NodeProps<AiAgentSmsFlowNode>) {
  const copy = useListCopy()
  // Raw {{...}} syntax stays in the data; the canvas shows token labels, as Send SMS does.
  const summary = data.brief.trim() ? humanizeTokens(data.brief, (token) => labelForToken(token, copy)) : `No brief yet`
  return (
    <NodeShell
      icon={SparkleIcon}
      accent="violet"
      kind="Hand off to AI agent"
      label={data.label}
      description={summary}
      selected={selected}
    />
  )
}
